import {get, isNil, negate} from 'lodash/fp';
import {createSelector} from 'reselect';

import {currentUser as currentUserState} from './root.selector';

export const userId = createSelector(currentUserState, get('userId'));

export const isSignedIn = createSelector(userId, negate(isNil));
